import { render, staticRenderFns } from "./IAIn.vue?vue&type=template&id=5b5b38ce&scoped=true"
import script from "./IAIn.vue?vue&type=script&lang=js"
export * from "./IAIn.vue?vue&type=script&lang=js"
import style0 from "./IAIn.vue?vue&type=style&index=0&id=5b5b38ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b38ce",
  null
  
)

export default component.exports